module.exports = __webpack_public_path__ + "static/table_arabic_6-b93de2377b658bef06decd19a7aa2f31.png";